import React from 'react';

import { Flex, useTheme } from '@chakra-ui/react';
import { Button, Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '@mesh.ai/rabbit';

import { Download } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

type Props = {
  options: Array<{
    title: string;
    description: string;
    onClick: () => void;
    isDisabled: boolean;
  }>;
};

const AgGirdDownloadMenu = ({ options }: Props) => {
  const theme = useTheme();
  return (
    <Dropdown>
      <DropdownTrigger>
        <Button size="icon" variant="text">
          <Download boxSize="24px" color={theme.colors.icon['1565BC']} />
        </Button>
      </DropdownTrigger>
      <DropdownContent
        align="end"
        style={{
          width: '250px',
        }}
      >
        {options.map((option, index) => {
          const { title, description, onClick, isDisabled } = option;
          return (
            <DropdownItem key={`dropdown-item-option-${index}`} onSelect={onClick} disabled={isDisabled}>
              <Flex flexDir="column">
                <TextBodyMedium bold mb="2px">
                  {title}
                </TextBodyMedium>
                <TextLabel color="text.g2">{description}</TextLabel>
              </Flex>
            </DropdownItem>
          );
        })}
      </DropdownContent>
    </Dropdown>
  );
};

export { AgGirdDownloadMenu };
